<div class="violations">
  <div class="table-actions">
    <app-violations-filters class="full-width" [pageFilters]="pageFilters"></app-violations-filters>
  </div>

  <div class="table-header">
    @if (totalItems > -1) {
      <div class="items-amount">
        {{ 'common.found' | labelsProvider }} {{ totalItems | number }}
        {{ 'violationsPage.title' | labelsProvider | lowercase }}
      </div>
    }
    <div class="table-header-right">
      <app-columns-selection
        class="columns-selection"
        [columns]="columns()"
        [pageName]="pageName"
        (columnsSelected)="columnsSelected($event)"
      >
      </app-columns-selection>

      @if (accessService.renderExportCSVButton(accountCategory$ | async)) {
        <div class="export-button-container">
          <app-violations-export
            [violationsDataType]="violationsDataType"
            [selectedFilters]="pageFilters.getSelectedFilters()"
            [sort]="sorts"
          ></app-violations-export>
        </div>
      }
    </div>
  </div>

  <div class="table">
    @if (multiActionsIsLoading$ | async) {
      <mat-progress-spinner class="multi-actions-loading" color="primary" mode="indeterminate"> </mat-progress-spinner>
    }

    <app-violations-vertical-filters
      [ngClass]="{ 'filters-all': isFiltersMenuOpen }"
      (optionOnSelection)="tablesFiltersChange($event)"
      [pageFilters]="pageFilters"
      [isFiltersMenuOpen]="isFiltersMenuOpen"
      (filtersOnMenuStateChange)="filtersOnMenuStateChange($event)"
    >
    </app-violations-vertical-filters>

    <app-prime-table
      #table
      [ngClass]="!isFiltersMenuOpen ? 'table-collapsed-menu' : 'table-component'"
      queryParamProperty="violation"
      [data$]="violationsCurrentPage$"
      [rowsPerPage]="defaultPageSize"
      [columns]="columns()"
      [isLoading]="(isLoading$ | async) === true"
      (checkedRowsUpdate)="onCheckboxClick($event)"
      [sortedColumn$]="pageFilters.sortedColumn$"
      [pageInfo]="pageInfo$.value"
      (pageOnChange)="onPagination($event)"
      (rowSelected)="rowSelected($event)"
      (rowUnselected)="rowUnselected()"
      (rowActionOnClick)="actionOnClick($event)"
      [checkedRowsSupportedActions$]="multiSelectedMenuActions$"
      (multiCheckOnClick)="multiSelectedActionClick($event)"
      [expandFilterResultControl]="expandFilterResultControl"
      tableNotFoundText="You don't have any violations"
      tableNotFoundIcon="assets/images/common/no-violations-found.svg"
    />
  </div>

  <!-- ZenAI Assistant -->
  @if (featureFlagsService.isFeatureEnabled(featureFlagTypes.ZenAI)) {
    <app-zen-ai-assistant [domain]="zenAIDomain.Violations"></app-zen-ai-assistant>
  }
</div>
